import { render } from "./TiendaProducto.vue?vue&type=template&id=fc72bc3c"
import script from "./TiendaProducto.vue?vue&type=script&lang=ts"
export * from "./TiendaProducto.vue?vue&type=script&lang=ts"
script.render = render

export default script